import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";

import moment from "moment";
import { OrderProps } from "../../types/order";

type Props = {
  order: OrderProps;
};

// A6 size in mm: 105mm x 148mm
const A6_WIDTH = "105mm";
const A6_HEIGHT = "148mm";

const OrderPdf = ({ order }: Props) => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  const [rotate, setRotate] = useState(false);

  useEffect(() => {
    if (order?.image) {
      const img = new Image();
      img.onload = () => {
        if (img.height > img.width) {
          setRotate(true);
        }
      };
      img.src = order.image;
    }
  }, [order?.image]);

  return (
    <div
      className="print-container"
      style={{
        width: A6_WIDTH,
        height: A6_HEIGHT,
        maxWidth: A6_WIDTH,
        maxHeight: A6_HEIGHT,
        padding: "5mm",
        boxSizing: "border-box",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Header */}
      <h1
        style={{
          fontSize: "18px",
          fontWeight: "bold",
          color: "black",
          textAlign: "center",
          margin: "0 0 8px 0",
        }}
      >
        {companyName}
      </h1>

      {/* Order Info */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "8px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <p style={{ fontSize: "12px", color: "black", margin: 0 }}>
            <span style={{ fontWeight: "bold" }}>Party</span>:{" "}
            {order?.party?.firm_name}
          </p>
          <p style={{ fontSize: "12px", color: "black", margin: 0 }}>
            <span style={{ fontWeight: "bold" }}>Date</span>:{" "}
            {order?.created_at
              ? moment(order?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  "DD-MM-YYYY"
                )
              : ""}
          </p>
          <p style={{ fontSize: "12px", color: "black", margin: 0 }}>
            <span style={{ fontWeight: "bold" }}>Time</span>:{" "}
            {order?.created_at
              ? moment(order?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  "hh:mm A"
                )
              : ""}
          </p>
        </div>
        <p style={{ fontSize: "12px", color: "black", margin: 0 }}>
          <span style={{ fontWeight: "bold" }}>Order No.</span>: {order?.id}
        </p>
      </div>

      {/* Image */}
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          margin: "20px 20px 30px 20px",
          minHeight: 0,
        }}
      >
        {order?.image && (
          <img
            src={`${order.image}?order=${order.id}`}
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transform: rotate ? "rotate(90deg)" : "none",
            }}
          />
        )}
      </div>

      {/* Table with QR Code */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "auto",
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                fontSize: "11px",
                color: "black",
                padding: "4px 6px",
                fontWeight: "bold",
                border: "1px solid black",
                width: "70px",
              }}
            >
              Item :
            </td>
            <td
              style={{
                fontSize: "11px",
                color: "black",
                padding: "4px 6px",
                fontWeight: "600",
                border: "1px solid black",
              }}
            >
              {order?.name ? `${order.name} - ` : ""}
              {order?.item?.name || ""}
              {order?.inch > 1 && ` ${order.inch} Inch`}
            </td>
            <td
              rowSpan={4}
              style={{
                border: "1px solid black",
                padding: "4px",
                verticalAlign: "middle",
                textAlign: "center",
                width: "78px",
              }}
            >
              <QRCodeSVG
                value={JSON.stringify({
                  order_id: order?.id,
                  party_id: order?.party_id,
                })}
                size={70}
              />
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: "11px",
                color: "black",
                padding: "4px 6px",
                fontWeight: "bold",
                border: "1px solid black",
              }}
            >
              Process :
            </td>
            <td
              style={{
                fontSize: "11px",
                color: "black",
                padding: "4px 6px",
                fontWeight: "600",
                border: "1px solid black",
              }}
            >
              {order?.process?.name || ""}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: "11px",
                color: "black",
                padding: "4px 6px",
                fontWeight: "bold",
                border: "1px solid black",
              }}
            >
              Qty :
            </td>
            <td
              style={{
                fontSize: "11px",
                color: "black",
                padding: "4px 6px",
                fontWeight: "600",
                border: "1px solid black",
              }}
            >
              {order?.qty || ""}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: "11px",
                color: "black",
                padding: "4px 6px",
                fontWeight: "bold",
                border: "1px solid black",
              }}
            >
              Ret. Qty :
            </td>
            <td
              style={{
                fontSize: "11px",
                color: "black",
                padding: "4px 6px",
                fontWeight: "600",
                border: "1px solid black",
              }}
            >
              {order?.delivered_qty || ""}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default OrderPdf;
